import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getStores, getTerminals } from "./constants.thunk";

const init_state = {
  data: {
    store: [],
    terminal: [],
  },
  loading: true,
};

export const fetchFnbStore = createAsyncThunk("fnb/constants/store", getStores);
export const fetchFnbTerminal = createAsyncThunk(
  "fnb/constants/terminal",
  getTerminals
);

const constantSlice = createSlice({
  name: "constants slice",
  initialState: init_state,
  extraReducers: (builder) => {
    builder
      .addCase(fetchFnbStore.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFnbStore.fulfilled, (state, action) => {
        state.data.store = action.payload.data.map((item) => item.name);
        state.loading = false;
      })
      .addCase(fetchFnbStore.rejected, (state) => {
        state.loading = false;
      })
      .addCase(fetchFnbTerminal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchFnbTerminal.fulfilled, (state, action) => {
        state.data.terminal = action.payload.data.map((item) => item.name);
        state.loading = false;
      })
      .addCase(fetchFnbTerminal.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default constantSlice.reducer;
